module.exports = __webpack_public_path__ + "static/images/styles/images/reserves/additional-briefing-clan-landing-big.c2b44039.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/reserves/additional-briefing-clan-landing-big.png
// module id = 3686
// module chunks = 11